import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'
import type { SNS } from '../../interfaces/common'

export interface SnsStoreInterface {
  sns: SNS[]
  setSns: (sns: SNS[]) => void
}

export const createSnsStore = (storage: StateStorage) =>
  createStore<SnsStoreInterface>(
    storage,
    (set) => ({
      sns: [],
      setSns: (sns) => {
        set({ sns })
      },
    }),
    {
      persist: {
        name: 'sns',
        version: 0,
      },
    }
  )
